// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Dimension/components/BasePlateFactor/styles.scss
// module id = 1294
// module chunks = 0